import { IDevice } from 'src/features/common/types/fees-slider-types';
import {
  ECommerceSmall,
  KwikaSmall,
  MaxSmall,
  TapOnPhoneSmall,
} from '../../../assets/icons/devices';
import { DEVICE_NAMES } from 'src/features/order/tech-debt/product-details-extra';

export const feeSliderDevices: IDevice[] = [
  {
    icon: MaxSmall,
    name: 'Max',
    functionality: 'Tap, Swipe, Scan',
    type: '*CP *CNP',
    active: false,
    businessName: DEVICE_NAMES.VODAPAY_MAX,
  },
  {
    icon: KwikaSmall,
    name: 'Kwika',
    functionality: 'Tap, Swipe',
    type: '*CNP',
    active: false,
    businessName: DEVICE_NAMES.VODAPAY_KWIKA,
  },
  {
    icon: ECommerceSmall,
    name: 'e-Commerce',
    functionality: 'Scan',
    type: '*CNP',
    active: false,
    businessName: DEVICE_NAMES.VODAPAY_ECOM_GATEWAY,
  },
  {
    icon: TapOnPhoneSmall,
    name: 'Tap on Phone',
    functionality: 'Scan',
    type: '*CP',
    active: false,
    businessName: DEVICE_NAMES.TAP_ON_PHONE,
  },
];

export const CNP = 'Card Not Present';
export const CP = 'Card Present';
